import { makeAutoObservable } from "mobx";

export default class Errormessage {
  errormessage = "";
  procedureErrormessage = "";

  constructor () {
    /**
      * state
      */
    this.errormessage = this.errormessage || "";
    this.errormessage = this.procedureErrormessage || "";
    makeAutoObservable(this);
  }

  /**
    * computed
    */
  get ErrorMessage () {
    return this.errormessage;
  }

  /**
    * action
    */
  setErrorMessage (val: any) {
    this.errormessage = val;
  }

  setProcedureErrormessage (val: any) {
    this.procedureErrormessage = val;
  }
}
